import * as React from 'react';

import cx from 'classnames';

import { Divider } from '~shared/components/Divider';
import { IconChevron, IconFolder } from '~shared/components/icons/standard';

export interface ListItemFolderProps {
  onClick: (e?: React.MouseEvent<HTMLElement>) => void;
  name: string;
  type: 'folder';
  uniqueId: string;
  isSelected?: boolean;
  isDisabled?: boolean;
}

export function QuizWorkspaceListItemFolder({
  name,
  uniqueId,
  isDisabled,
  onClick,
}: ListItemFolderProps) {
  const listClass = cx(
    'flex flex-row items-center justify-start py-4',
    !isDisabled ? 'cursor-pointer' : 'cursor-default'
  );

  const iconClass = cx(
    'flex items-center justify-start min-w-30',
    isDisabled && 'opacity-50'
  );
  const textClass = cx('pl-6 group text-base font-500 leading-8 w-full', {
    'text-blue-900 hover:text-cyan-700 truncate': !isDisabled,
    'text-grey-800 hover:text-grey-800': isDisabled,
  });

  return (
    <>
      <li
        className={listClass}
        onClick={isDisabled ? () => {} : onClick}
        key={uniqueId}
      >
        <div className={iconClass}>
          <IconFolder />
        </div>
        <span className={textClass}>{name}</span>
        <div className={iconClass}>
          <IconChevron direction="right" />
        </div>
      </li>
      <Divider />
    </>
  );
}
